import React, { useContext, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { ChatContext } from '../../contexts/ChatContext';
import userService from '../../services/userService';

const AnnouncementDialog = () => {
  const { announcement } = useContext(ChatContext);
  const [isOpen, setIsOpen] = useState(false);

  const markAnnouncementAsRead = () => {
    userService.markAnnouncementAsRead(announcement.announcementId);
  };

  const onClose = () => {
    setIsOpen(false);
    markAnnouncementAsRead();
  };

  useEffect(() => {
    if (announcement) {
      setIsOpen(announcement?.hasReaded === false);
    }
  }, [announcement]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth={announcement?.modalSize}
    >
      <DialogTitle>{announcement?.title}</DialogTitle>
      <DialogContent>
        <div
          dangerouslySetInnerHTML={{ __html: announcement?.innerHtml }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          color="secondary"
          variant="contained"
          type="button"
        >
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnnouncementDialog;
